import { render } from "./Permissoes.vue?vue&type=template&id=95f25208&scoped=true"
import script from "./Permissoes.vue?vue&type=script&lang=js"
export * from "./Permissoes.vue?vue&type=script&lang=js"

import "./Permissoes.vue?vue&type=style&index=0&id=95f25208&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f25208"]])

export default __exports__